import React from 'react';
import styled from 'styled-components'
import FacebookIcon from '../../images/assets/facebook-black.svg'
import TwitterIcon from '../../images/assets/twitter-black.svg'
import InstagramIcon from '../../images/assets/instagram-black.svg'
import IconButton from '../Layout/Button/IconButton'

const SocialLinksMiniBlack = props => (

    <IconContainer>
        <IconButton size="20px" padding="5px" onClick={(event) => handleClick("https://www.facebook.com/summoncars")}>
            <FacebookIcon/> 
        </IconButton>
        <IconButton size="20px" padding="5px" onClick={(event) => handleClick("https://www.twitter.com/summon_cars")}>
            <TwitterIcon/> 
        </IconButton>
        <IconButton size="20px" padding="5px" onClick={(event) => handleClick("https://www.instagram.com/summoncars")}>
            <InstagramIcon/> 
        </IconButton>
    </IconContainer>

);

const handleClick = (url) => {
    const a = document.createElement("a");
    a.href = url;
    a.target = "_blank";
    a.rel = "noopener";
    a.click();
}


const IconContainer = styled.div`
    padding-bottom: 0px;
`;

export default SocialLinksMiniBlack;


